import * as Yup from 'yup';

const regionSchema = Yup.object().shape({
  labelEn: Yup.string().required('English Label is required.'),
  code: Yup.string().required('Code is required.'),
  countryId: Yup.string().required('Country is required.'),
  // ccy: Yup.string().required('CCY is required.'),
  decimalPlaces: Yup.number()
    .min(0, "Please enter more than 0")
    .max(10, "Please enter less than 10")
    .required("Decimal Places is required.")
    .typeError("Must be Number"),
  vatRate: Yup.number()
    .min(0, "Please enter more than 0")
    .required("VAT Rate is required.")
    .typeError("Must be Number"),
  printingCharges: Yup.number()
    .min(0, "Please enter more than 0")
    .required("Printing Charges is required.")
    .typeError("Must be Number"),
  // deliveryUpto: Yup.number()
  //   .min(0, "Please enter more than 0")
  //   .required("Delivery Upto is required.")
  //   .typeError("Must be Number"),
});

export default regionSchema;